import { render, staticRenderFns } from "./detail--patch.vue?vue&type=template&id=87c831ea&"
import script from "./detail--patch.vue?vue&type=script&lang=js&"
export * from "./detail--patch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports